import { useState, useCallback } from "react";

const INITIAL = { name: "", company: "", phone: "", location: "", requirement: "", message: "" };

function validate(form) {
  const e = {};
  if (!form.name.trim()) e.name = "Please enter your name.";
  if (!form.phone.trim()) e.phone = "Please enter a phone number.";
  if (!form.requirement) e.requirement = "Please pick a requirement.";
  return e;
}

function buildWhatsAppUrl(form) {
  const msg =
    `New enquiry from yadurajenterprises.com — ` +
    `Name: ${form.name}, ` +
    `Company: ${form.company || "-"}, ` +
    `Phone: ${form.phone}, ` +
    `Location: ${form.location || "-"}, ` +
    `Requirement: ${form.requirement}, ` +
    `Message: ${form.message || "-"}`;
  return `https://wa.me/917689912984?text=${encodeURIComponent(msg)}`;
}

export default function useEnquiryForm() {
  const [form, setForm] = useState(INITIAL);
  const [errors, setErrors] = useState({});

  const handleChange = useCallback(
    (key) => (event) => setForm((prev) => ({ ...prev, [key]: event.target.value })),
    [],
  );

  const handleSubmit = useCallback(
    (event) => {
      event.preventDefault();
      const next = validate(form);
      setErrors(next);
      if (Object.keys(next).length > 0) return;
      window.open(buildWhatsAppUrl(form), "_blank", "noopener,noreferrer");
    },
    [form],
  );

  return { form, errors, handleChange, handleSubmit };
}
